import firebase from "firebase/app";
import { db } from "../index.js";

export const createAccount = async (username, email, password) => {
  try {
    const userCreds = await firebase.auth().createUserWithEmailAndPassword(email, password);

    if (userCreds) {
      const user = userCreds.user;
      await db.collection("users").doc(user.uid).set(
        {
          id: user.uid,
          emailAddress: user.email,
          verified: user.emailVerified,
          userName: username,
          userNameForSearch: username.toLowerCase(),
          photoUrl: "",
          private: true,
        },
        { merge: true }
      );
      await db
        .collection("followers")
        .doc(user.uid)
        .set({ followers: [], recentActivity: [], lastActivity: "" });
    }

    const user = firebase.auth().currentUser;
    const isMailSuccessful = user
      .sendEmailVerification()
      .then(function () {
        return true;
      })
      .catch(function (error) {
        alert("Fehler bei der Registrierung. Dir konnte kein Bestätigungslink gesendet werden.");
        return false;
      });

    const signOut = firebase
      .auth()
      .signOut()
      .then(function () {
        return true;
      })
      .catch(function (error) {
        alert("Fehler bei der Registrierung.");
        return false;
      });

    if (signOut) {
      return isMailSuccessful;
    }

    return false;
  } catch (e) {
    throw new Error(e.message);
  }
};
